<p-panel *ngIf="coreLibService.getSecurityInformation().userProfile != null" i18n-header="@@appointment-filter-settings.additionalSettings" header="Additional Settings">
    <div>
        <div class="flex align-items-center filterCheckbox">
            <div>
                <p-checkbox id="filterMyEvents" [binary]="true" [(ngModel)]="filterMyEvents"></p-checkbox>
            </div>

            <label for="filterMyEvents" i18n="@@appointment-filter-settings.additionalSettings.showOwnSignUps" class="text-sm ml-2 filterCheckboxLabel">
                Show only your own sign-ups.
            </label>
        </div>

        <div class="flex align-items-center mt-2 filterCheckbox">
            <div>
                <p-checkbox id="filterOnlyWithFreeSignUpSlots" [binary]="true" [(ngModel)]="filterOnlyWithFreeSignUpSlots"></p-checkbox>
            </div>

            <label for="filterOnlyWithFreeSignUpSlots" i18n="@@appointment-filter-settings.additionalSettings.filterOnlyWithFreeSignUpSlots" class="text-sm ml-2 filterCheckboxLabel">
                Show only events with available spaces.
            </label>
        </div>

        <div class="flex align-items-center mt-2 filterCheckbox">
            <div>
                <p-checkbox id="dontFilterUpcomingEvents" [binary]="true" [(ngModel)]="dontFilterUpcomingEvents"></p-checkbox>
            </div>

            <label for="dontFilterUpcomingEvents" i18n="@@appointment-filter-settings.additionalSettings.dontFilterUpcomingEvents" class="text-sm ml-2 filterCheckboxLabel">
                Show past events
            </label>
        </div>

        <div class="flex align-items-center mt-2 filterCheckbox">
            <div>
                <p-checkbox id="onlyShowFavorites" [binary]="true" [(ngModel)]="onlyShowFavorites"></p-checkbox>
            </div>

            <label for="onlyShowFavorites" i18n="@@appointment-filter-settings.additionalSettings.onlyShowFavorites" class="text-sm ml-2 filterCheckboxLabel">
                Only show Favorites
            </label>
        </div>
    </div>
</p-panel>


<p-panel i18n-header="@@appointment-filter-settings.calendars" header="Calendars" styleClass="mt-3">
    <div>

        <div i18n="@@appointment-filter-settings.calendar-description" class="text-sm mb-2 calendarText">
            Please select calendars to show.
        </div>

        <div class="flex align-items-center mb-2 ml-1 mt-3 calendarCheckbox">
            <p-checkbox id="calendarAllSelected" [(ngModel)]="allSelected" binary="true" (onChange)="toggleAll($event)"></p-checkbox>
            <label for="calendarAllSelected" class="ml-2 calendarCheckboxLabel">
                <span *ngIf="allSelected" i18n="@@appointment-filter-settings.deselectall">Deselect all</span>
                <span *ngIf="!allSelected" i18n="@@appointment-filter-settings.selectall">Select all</span>
            </label>
        </div>

        <p-listbox [options]="calendars" [(ngModel)]="selectedCalendarIds" [checkbox]="true" [filter]="false" optionValue="id" class="calendarSelect"
            [showToggleAll]="false" [multiple]="true" (onChange)="onSelectionChange()" [listStyle]="{'max-height':'250px','min-height':'50px'}"
            [style]="{'width':'100%'}" >
            <ng-template let-calendar pTemplate="item">
                <div class="flex align-items-center">
                    <div class="h-2rem w-2rem swatch calendarSelectColor" [style.background-color]="calendar.color"></div>
                    <div class="ml-2 calendarSelectLabel">{{calendar.title}}</div>
                </div>
            </ng-template>
        </p-listbox>

    </div>
</p-panel>


<p-panel i18n-header="@@appointment-filter-settings.locations" header="Locations" styleClass="mt-3">
    <div>
        <div i18n="@@appointment-filter-settings.location-description" class="text-sm mb-2 locationText">
            Please select locations to narrow down your search. If no location is picked, no filter will be applied.
        </div>
        <p-listbox [options]="locations" [(ngModel)]="selectedLocationIds" [checkbox]="true" [filter]="false"
            optionLabel="title" optionValue="id" [showToggleAll]="false" [multiple]="true" class="locationSelect"
            [listStyle]="{'max-height':'250px','min-height':'50px'}" [style]="{'width':'100%'}">
            <ng-template let-location pTemplate="item">
                <div class="flex flex-row justify-content-between w-full">
                    <div class="flex flex-column pr-2">
                        <div class="text-lg locationSelectLabel">{{location.title}}</div>
                        <div class="text-sm locationSelectAdress">
                            <div>{{location.street}}</div>
                            <div>{{location.city}} {{location.postalCode}}</div>
                        </div>
                    </div>
                    <div class="mr-2" *ngIf="location.geoLat && location.geoLng locationSelectCoordinates">
                        <img class="shadow-2 w-4rem" style="border-radius: 5px" [src]="apiURL + '/file-api/location-image/' + location.id + '?access_token=' + coreLibService.getJWTToken()">
                    </div>
                </div>
            </ng-template>
        </p-listbox>
    </div>
</p-panel>

<ng-container *ngIf="isFilterActive">
    <div class="mt-3"></div>
    <div class="flex justify-content-start mb-5 resetButton">
        <p-checkbox id="resetFilter" [binary]="true" [(ngModel)]="resetFilter"></p-checkbox>
        <label class="ml-2" for="resetFilter" i18n="@@appointment-filter-settings.button.reset">reset filter</label>
    </div>

</ng-container>

<div class="mt-3"></div>

<div class="flex justify-content-between buttonBox">
    <p-button type="button" severity="secondary" class="cancelButton" (click)="this.ref.close(null)" label="Cancel"
        i18n-label="@@appointment-filter-settings.button.cancel"></p-button>
    <p-button type="button" severity="secondary" class="saveButton" (click)="onSave()" label="Apply"
        i18n-label="@@appointment-filter-settings.button.apply"></p-button>
</div>
